<template>
  <div>
    <div class="page">
      <div v-if="prizeList.length" class="prize-list">
        <div
          v-for="(item, index) in prizeList"
          :id="`prize-${item.id}`"
          :key="item.id || item.orderNo || index"
          class="prize-card"
          :class="{ pending: !isSuccess(item), expanded: item._expanded }"
        >
          <div class="card-head"></div>
          <div class="card-middle">
            <div v-if="getAwardName(item.rightLevel)" class="ribbon">
              {{ getAwardName(item.rightLevel) }}
            </div>

            <img
              v-if="!isSuccess(item)"
              class="fail-stamp"
              :src="failStamp"
              alt="发放中"
            />

            <div class="card-body">
              <img
                class="prize-img"
                :src="item.gcMainUrl || item.gcCoverUrl || defaultPrizeImg"
                alt=""
              />
              <div class="prize-right">
                <p class="prize-name">{{ item.goodsName }}</p>

                <template v-if="isSuccess(item)">
                  <div v-if="item.card.cardNo" class="code-row">
                    <span class="code-text">卡号：{{ item.card.cardNo }}</span>
                    <span
                      class="copy-btn"
                      v-clipboard:copy="String(item.card.cardNo)"
                      @click="onCopy"
                    >
                      复制
                    </span>
                  </div>

                  <div v-if="item.card.cardPwd" class="code-row">
                    <span class="code-text">卡密：{{ item.card.cardPwd }}</span>
                    <span
                      class="copy-btn"
                      v-clipboard:copy="String(item.card.cardPwd)"
                      @click="onCopy"
                    >
                      复制
                    </span>
                  </div>

                  <div v-if="item.card.shortUrl" class="code-row">
                    <span class="code-text">
                      短链：
                      <span
                        v-if="isHttpLink(item.card.shortUrl)"
                        class="link-text"
                        @click="openLink(item.card.shortUrl)"
                      >
                        {{ item.card.shortUrl }}
                      </span>
                      <template v-else>{{ item.card.shortUrl }}</template>
                    </span>
                    <span
                      class="copy-btn"
                      v-clipboard:copy="String(item.card.shortUrl)"
                      @click="onCopy"
                    >
                      复制
                    </span>
                  </div>

                  <div v-if="item.card.verifyCode" class="code-row">
                    <span class="code-text">
                      验证码：{{ item.card.verifyCode }}
                    </span>
                    <span
                      class="copy-btn"
                      v-clipboard:copy="String(item.card.verifyCode)"
                      @click="onCopy"
                    >
                      复制
                    </span>
                  </div>

                  <div v-if="item.card.redeemCode" class="code-row">
                    <span class="code-text">
                      兑换码：
                      <span
                        v-if="isHttpLink(item.card.redeemCode)"
                        class="link-text"
                        @click="openLink(item.card.redeemCode)"
                      >
                        {{ item.card.redeemCode }}
                      </span>
                      <template v-else>{{ item.card.redeemCode }}</template>
                    </span>
                    <span
                      class="copy-btn"
                      v-clipboard:copy="String(item.card.redeemCode)"
                      @click="onCopy"
                    >
                      复制
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <div class="dash"></div>

            <template v-if="isSuccess(item)">
              <p v-if="item.card.expireTime" class="expire">
                有效期至：{{ item.card.expireTime }}
              </p>
              <img
                v-if="item.gcText"
                class="expand"
                :class="{ up: item._expanded }"
                :src="expandIcon"
                alt=""
                @click="toggleExpand(item)"
              />
              <div v-if="item._expanded && item.gcText" class="usage-block">
                <div class="usage-title">·使用说明·</div>
                <div class="usage-content" v-html="item.gcText"></div>
              </div>
            </template>

            <p v-else class="pending-msg">
              系统发放中！<br />
              订单号:{{ item.orderNo || '-' }}
            </p>
          </div>
          <div class="card-foot"></div>
        </div>
      </div>

      <div v-else class="empty">暂无奖品～</div>
    </div>

    <div
      v-if="prizeList.length"
      class="card-back"
      @click="$router.push({ name: 'erkeAiStoreAward' })"
    >
      返回
    </div>
  </div>
</template>

<script>
import { getToken, getOrderPages } from '@/api/erkeAiStore'

const AWARD_NAME_MAP = {
  1: '首检先锋奖',
  2: '领跑先锋奖',
  3: '优秀标杆奖'
}

export default {
  name: 'ErkeAiStoreMyPrize',
  data() {
    return {
      prizeList: [],
      defaultPrizeImg: require('@/assets/img/erkeAiStore/my-prize-img.png'),
      expandIcon: require('@/assets/img/erkeAiStore/my-expand.png'),
      failStamp: require('@/assets/img/erkeAiStore/sendStatus.png')
    }
  },
  created() {
    if (!getToken()) {
      this.$router.replace({ name: 'erkeAiStoreLogin' })
      return
    }
    this.fetchMyPrize()
  },
  methods: {
    // rightLevel: 1首检先锋奖 2领跑先锋奖 3优秀标杆奖
    getAwardName(rightLevel) {
      return AWARD_NAME_MAP[rightLevel] || ''
    },
    // receiveStatus: 0待领取 1已领取 2领取失败 3领取中
    isSuccess(item) {
      return item.receiveStatus === 1
    },
    isHttpLink(url) {
      return /^https?:\/\//i.test(String(url || ''))
    },
    openLink(url) {
      if (!this.isHttpLink(url)) return
      window.open(url, '_blank')
    },
    toggleExpand(item) {
      this.$set(item, '_expanded', !item._expanded)
    },
    onCopy() {
      this.$toast.success('复制成功')
    },
    scrollToPrize() {
      const id = this.$route.query.id
      if (!id) return
      const el = document.getElementById(`prize-${id}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    async fetchMyPrize() {
      try {
        const { code, data } = await getOrderPages({
          pageNum: 1,
          pageSize: 100,
          param: {}
        })
        if (code === 0 && data) {
          const list = Array.isArray(data.records) ? data.records : []
          this.prizeList = list.map(item => ({
            ...item,
            card: (item.cardList && item.cardList[0]) || {},
            _expanded: false
          }))
          this.$nextTick(this.scrollToPrize)
        } else {
          this.prizeList = []
        }
      } catch (e) {
        this.prizeList = []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #fff8f0;
  padding: 16px 8px 75px;
  box-sizing: border-box;
}

.prize-card {
  margin-bottom: 12px;

  .card-head {
    height: 40px;
    background: url('~@/assets/img/erkeAiStore/my-card-head.png') center / 100%
      100% no-repeat;
  }

  .card-middle {
    position: relative;
    background: url('~@/assets/img/erkeAiStore/my-card-middle.png') center /
      100% 100% no-repeat;
    padding: 0 28px 8px;
    box-sizing: border-box;
    min-height: 100px;
  }

  .card-foot {
    height: 40px;
    background: url('~@/assets/img/erkeAiStore/my-card-foot.png') center / 100%
      100% no-repeat;
  }

  .ribbon {
    position: absolute;
    top: -28px;
    right: 8px;
    width: 85px;
    height: 35px;
    background: url('~@/assets/img/erkeAiStore/my-ribbon.png') center / 100%
      100% no-repeat;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    line-height: 28px;
    text-align: center;
    padding-left: 4px;
    box-sizing: border-box;
    z-index: 2;
  }

  .fail-stamp {
    position: absolute;
    top: 20px;
    right: 25px;
    width: 75px;
    height: auto;
    z-index: 2;
  }

  .card-body {
    display: flex;
    align-items: center;
    padding-top: 4px;

    .prize-img {
      width: 110px;
      height: 72px;
      flex-shrink: 0;
      object-fit: contain;
      border-radius: 10px;
    }

    .prize-right {
      flex: 1;
      margin-left: 10px;
      min-width: 0;
      padding-right: 4px;

      .prize-name {
        margin: 0;
        font-size: 15px;
        font-weight: 500;
        color: #010101;
        line-height: 1.2;
      }

      .code-row {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .code-text {
          flex: 1;
          font-size: 12px;
          color: #666;
          min-width: 0;
          word-break: break-all;
        }

        .link-text {
          color: #f9421a;
          word-break: break-all;
          border-bottom: 1px solid #f9421a;
        }

        .copy-btn {
          flex-shrink: 0;
          width: 48px;
          height: 20px;
          margin-left: 8px;
          background: #000;
          border-radius: 10px;
          color: #fff;
          font-size: 13px;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }

  .dash {
    margin: 14px 0 10px;
    border-top: 1px dashed #cacaca;
  }

  .expire {
    margin: 0;
    font-size: 12px;
    color: #999;
    line-height: 1.2;
  }

  .expand {
    display: block;
    width: 13px;
    height: 14px;
    margin: 12px auto 4px;

    &.up {
      transform: rotate(180deg);
    }
  }

  .usage-block {
    margin-top: 8px;
    padding-bottom: 8px;

    .usage-title {
      text-align: center;
      font-size: 17px;
      color: #000;
      margin-bottom: 12px;
      letter-spacing: 2px;
    }

    .usage-content {
      font-size: 12px;
      color: #666;
      line-height: 20px;
    }
  }

  .pending-msg {
    margin: 0;
    font-size: 12px;
    color: #999;
    line-height: 18px;
  }
}

.card-back {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 205px;
  height: 72px;
  background: url('~@/assets/img/erkeAiStore/my-card-back.png') center / 100%
    100% no-repeat;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
  line-height: 72px;
  text-align: center;
}

.empty {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 130px;
  width: 109px;
  box-sizing: border-box;
  background: url('~@/assets/img/erkeAiStore/empty.png') center center no-repeat;
  background-size: contain;
  text-align: center;
  color: #999;
  font-size: 14px;
  line-height: 1.4;
}
</style>
